import React from "react";
import { connect } from "react-redux";
import { sha256 } from "js-sha256";
// import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  Input,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap";
import ReactStickyHeadroom from "@integreat-app/react-sticky-headroom";
import { withTranslation } from "react-i18next";
import getSymbolFromCurrency from "currency-symbol-map";
import {
  logoutUser,
  resetApp,
  resetLogout,
} from "../../redux/actions/authActions";
import {
  getRegenerateToken,
  resetRegenerateToken,
} from "../../redux/actions/regenerateTokenAction";
import {
  showWalletBalance,
  setSelectedCurrency,
} from "../../redux/actions/showWalletBalanceAction";
import dashboardRoutes from "../../routes/dashboard.jsx";
import ChangePassword from "./ChangePassword.jsx";
// import MerchantAPI from "./MerchantAPI.jsx";
import Notification from "./Notification.jsx";
import val from "../../getThemeDetails";
import CL from "./CL";
import Cart from "../../views/Carts/Cart";
import QRCode from "./QRCode";
import { getCartList } from "../../redux/actions/marketPlaceAction";
import BackDrop from "../BackDrop/BackDrop";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import constants from "../../config/constants";
import Home from "./Home";

class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      dropdownOpen: false,
      color: "transparent",
      cPasswordModalOpen: false,
      counter: 0,
      converterModalOpen: false,
    };

    [
      "toggle",
      "openSidebar",
      "dropdownToggle",
      "handleChangePassword",
      "handleLogout",
      "profileRouteHandler",
      "upgradeWalletHandler",
      "currencyConverterHandler",
      "handleWalletAmountRefresh",
      "handleChangeCurrency",
      "handleCustomerSupport",
      "handleMerchantApi",
      // "regenerateToken",
    ].forEach((v) => {
      this[v] = this[v].bind(this);
    });
  }

  toggle() {
    if (this.state.isOpen) {
      this.setState({
        color: "transparent",
      });
    } else {
      this.setState({
        color: "dark",
      });
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  dropdownToggle(e) {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  getBrand() {
    var name;
    dashboardRoutes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        } else {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        }
      }
      return null;
    });

    return this.props.t(name);
  }
  openSidebar() {
    document.documentElement.classList.toggle("nav-open");
    this.refs.sidebarToggle.classList.toggle("toggled");
  }
  // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
  updateColor() {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
        color: "dark",
      });
    } else {
      this.setState({
        color: "transparent",
      });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateColor.bind(this));
    if (this.props.regenerateTkn.success) {
      this.props.getCartList(
        this.getReq("cart"),
        this.props.regenerateTkn.data.authToken
      );
    }
    this.regenerateToken();
    this.getbreadcrumb();

    // setInterval(() => {
    //   this.regenerateToken();
    // }, 60000 * 20);
  }

  // regenerateToken() {
  //   const regenerateTokenReq = {
  //     authentication: {
  //       partnerId: this.props.login.data.partnerId,
  //     },
  //     authToken: this.props.login.data.AuthToken,
  //   };

  //   return this.props.getRegenerateToken(regenerateTokenReq);
  // }

  componentDidUpdate(e) {
    // console.log("prevProps", e);
    const {
      showWalletBalanceState,
      buyProductState,
      getCartList,
      resetLogout,
      logout,
      regenerateSecKeyState,
      t,
      regenerateTkn,
      authTkn,
    } = this.props;
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      this.refs.sidebarToggle.classList.toggle("toggled");
    }

    if (
      e.showWalletBalanceState.selectedCurrency !==
      showWalletBalanceState.selectedCurrency ||
      e.buyProductState.success !== buyProductState.success
    ) {
      getCartList(this.getReq("cart"));
    }

    if (e.logout.failed !== logout.failed) {
      swalWithBootstrapButtons.fire({
        type: "error",
        title: "Oops!!",
        text: t(logout.status),
        onClose: () => {
          resetLogout();
        },
      });
    }

    if (
      regenerateSecKeyState.success !== e.regenerateSecKeyState.success &&
      logout.invalidRequest !== e.logout.invalidRequest
    ) {
      this.props.logoutUser(this.getReq("logout"));
    }
    if (regenerateTkn.success !== e.regenerateTkn.sucess) {
      localStorage.setItem("authToken", regenerateTkn.data.authToken);
      sessionStorage.setItem("authToken", regenerateTkn.data.authToken)
      sessionStorage.setItem("walletOwnerId",this.props.login.data.partnerId);

    }

    // if (authTkn.success !== e.authTkn.success) {
    //   this.regenerateToken();
    // }
    this.regenerateToken();
  }

  handleLogout() {
    sessionStorage.removeItem("persist:root");
    sessionStorage.removeItem("secKey");
    this.props.logoutUser(this.getReq("logout"));
  }

  profileRouteHandler() {
    this.setState({ dropdownOpen: false });
    // this.props.history.push("/index/profile");
    this.props.history.push("/index/customer-master");
  }

  // loyaltyPointsHandler() {
  //   this.setState({ dropdownOpen: false });
  //   this.props.history.push("/index/loyalty-points");
  // }

  upgradeWalletHandler() {
    this.setState({ dropdownOpen: false });
    this.props.history.push("/index/upgrade-wallet");
  }

  handleCustomerSupport() {
    this.setState({ dropdownOpen: false });
    this.props.history.push("/index/customer-support");
  }

  handleMerchantApi() {
    this.setState({ dropdownOpen: false });
    this.props.history.push("/index/merchant-api");
  }

  handleChangePassword() {
    this.setState((state) => ({
      cPasswordModalOpen: !state.cPasswordModalOpen,
      counter: state.counter + 1,
      dropdownOpen: false,
    }));
  }

  currencyConverterHandler() {
    this.setState({ dropdownOpen: false });
    this.props.history.push("/index/currency-converter");
  }

  getReq(type) {
    const { secKey, customerId } = this.props.login.data;
    const verificationHash =
      type !== "logout"
        ? sha256(secKey + customerId)
        : sha256(secKey + customerId + "3");

    const commonReq = {
      customerId,
      verificationHash,
    };

    if (type === "logout") {
      return {
        ...commonReq,
        // platformId: "3",
        platformId: "1",
        cust_device_id: "",
      };
    }

    if (type === "cart") {
      const { selectedCurrency } = this.props.showWalletBalanceState;
      return {
        ...commonReq,
        currency: selectedCurrency,
        walletOwnerId: val.walletOwnerId,
      };
    }

    return {
      ...commonReq,
      walletOwnerId: val.walletOwnerId,
    };
  }

  handleWalletAmountRefresh() {
    this.props.showWalletBalance(this.getReq("refresh"));
  }

  handleChangeCurrency({ target: { value } }) {
    this.props.setSelectedCurrency(value);
  }

  render() {
    const {
      t,
      showWalletBalanceState,
      login,
      cartList,
      logout,
      walletSetting,
    } = this.props;
    !this.props.login.data && this.props.history.replace("/login");

    return (
      // add or remove classes depending if we are on full-screen-maps page or not
      <React.Fragment>
        <BackDrop isBackdropVisible={logout.isLoading} />
        <ReactStickyHeadroom>
          <Navbar
            color={
              this.props.location.pathname.indexOf("full-screen-maps") !== -1
                ? "dark"
                : this.state.color
            }
            expand="lg"
            className={
              this.props.location.pathname.indexOf("full-screen-maps") !== -1
                ? "navbar-absolute fixed-top"
                : "navbar-absolute fixed-top " +
                (this.state.color === "transparent"
                  ? "navbar-transparent "
                  : "")
            }
          >
            <Container fluid>
              <div className="navbar-wrapper">
                <div className="navbar-toggle">
                  <button
                    type="button"
                    ref="sidebarToggle"
                    className="navbar-toggler"
                    onClick={this.openSidebar}
                  >
                    <span className="navbar-toggler-bar bar1" />
                    <span className="navbar-toggler-bar bar2" />
                    <span className="navbar-toggler-bar bar3" />
                  </button>
                </div>
                <NavbarBrand className="hideForSmall">
                  {this.props.servicename}
                  {" / "}
                  {/* {this.regenerateToken()} */}
                  {/* <Breadcrumb >
                    <BreadcrumbItem >{this.props.servicename}</BreadcrumbItem>
                    <BreadcrumbItem >{this.getBrand()}</BreadcrumbItem>
                  </Breadcrumb> */}
                  {/* {this.getBrand()} */}
                </NavbarBrand>
              </div>

              {/* <div> */}
              {/* <div
                style={{ margin: "0 auto", zIndex: 9999 }}
                className="forBigScreenHide"
              >
                <span className="wallet-bal">
                  <Input
                    type="select"
                    className="db-wal-bal"
                    onChange={this.handleChangeCurrency}
                  >
                    {showWalletBalanceState.data.walletBalanceList &&
                    showWalletBalanceState.data.walletBalanceList.length ? (
                      showWalletBalanceState.data.walletBalanceList.map(
                        (opt) => (
                          <option
                            key={opt.currency}
                            value={opt.currency}
                            selected={
                              showWalletBalanceState.selectedCurrency
                                ? showWalletBalanceState.selectedCurrency ===
                                  opt.currency
                                : opt.isDefault === "Y"
                            }
                            defaultValue={
                              showWalletBalanceState.selectedCurrency
                                ? showWalletBalanceState.selectedCurrency ===
                                  opt.currency
                                : opt.isDefault === "Y"
                            }
                            // defaultValue={opt.isDefault === 'Y'}
                            // selected={
                            //   showWalletBalanceState.selectedCurrency
                            //     ? showWalletBalanceState.selectedCurrency ===
                            //       opt.currency
                            //     : opt.isDefault === "Y"
                            // }
                          >
                            {getSymbolFromCurrency(opt.currency) +
                              " " +
                              opt.balance}
                          </option>
                        )
                      )
                    ) : (
                      <option className="loading" />
                    )}
                  </Input>
                  <i
                    className={`fas fa-refresh ${
                      showWalletBalanceState.isLoading && "fa-spin"
                    } ml-2`}
                    onClick={this.handleWalletAmountRefresh}
                  />
                </span>
              </div>
               */}
              {/* <div className="showForSmall">
                <Home />
              </div> */}
              <div className="showForSmall">
                <Cart cartList={cartList} />
              </div>
              <div className="showForSmall">
                <CL />
              </div>
              {/* <div className="showForSmall">
                <Notification />
              </div> */}
              <div className="showForSmall">
                <QRCode />
              </div>

              <NavbarToggler onClick={this.toggle}>
                <span className="navbar-toggler-bar navbar-kebab" />
                <span className="navbar-toggler-bar navbar-kebab" />
                <span className="navbar-toggler-bar navbar-kebab" />
              </NavbarToggler>

              <Collapse
                style={{ position: "relative", flexGrow: "0" }}
                isOpen={this.state.isOpen}
                navbar
                className="justify-content-end"
              >
                <Nav navbar style={{ flexDirection: "row" }}>
                  <NavItem className="hideForSmall">
                    <Home />
                  </NavItem>
                  <NavItem className="hideForSmall">
                    <Cart cartList={cartList} />
                  </NavItem>
                  <NavItem className="hideForSmall">
                    <CL />
                  </NavItem>
                  <NavItem className="hideForSmall">
                    <Notification />
                  </NavItem>
                  <NavItem className="hideForSmall">
                    <QRCode />
                  </NavItem>
                  <NavItem className="showForSmall">
                    <NavbarBrand>{this.props.servicename}</NavbarBrand>
                    <NavbarBrand>{this.getBrand()}</NavbarBrand>
                  </NavItem>
                  <Dropdown
                    nav
                    isOpen={this.state.dropdownOpen}
                    toggle={this.dropdownToggle}
                    style={{ flexGrow: 1, marginTop: "4px" }}
                  >
                    <DropdownToggle caret nav className="float-right">
                      <i
                        className="fa fa-user"
                        style={{ marginTop: "-20px!important" }}
                      />
                    </DropdownToggle>
                    <DropdownMenu right className="user-dropdown">
                      {constants.visibleFlags.includes(
                        walletSetting.data.isProfileSetting
                      ) && (
                          <DropdownItem header>
                            <div onClick={this.profileRouteHandler}>
                              {t("Your Profile")}
                            </div>
                          </DropdownItem>
                        )}
                      {login.data.accountType !== "DSR" &&
                        login.data.entityType === "Individual" && (
                          <DropdownItem header>
                            <div onClick={this.upgradeWalletHandler}>
                              {t("Upgrade Wallet")}
                            </div>
                          </DropdownItem>
                        )}

                      {/* {login.data.isLoyaltyPointsAllowed === "Y" && (
                        <DropdownItem header>
                          <div onClick={this.loyaltyPointsHandler}>
                            {t("Loyalty Points")}
                          </div>
                        </DropdownItem>
                      )} */}
                      <DropdownItem header className="change-password">
                        <div onClick={this.handleChangePassword}>
                          {t("Change Password")}
                        </div>
                      </DropdownItem>
                      {constants.visibleFlags.includes(
                        walletSetting.data.apiKey
                      ) && (
                          <DropdownItem header className="merchant-api">
                            <div onClick={this.handleMerchantApi}>
                              {t("API KEY")}
                            </div>
                          </DropdownItem>
                        )}
                      <DropdownItem divider />
                      <DropdownItem header className="customer-support">
                        <div onClick={this.handleCustomerSupport}>
                          {t("Help & Support")}
                        </div>
                      </DropdownItem>
                      <DropdownItem header className="logout">
                        <div onClick={this.handleLogout}>{t("Logout")}</div>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <NavItem />
                </Nav>
              </Collapse>
            </Container>
          </Navbar>
        </ReactStickyHeadroom>
        {this.state.cPasswordModalOpen ? (
          <ChangePassword
            cPasswordModalOpen={this.state.cPasswordModalOpen}
            toggleModal={this.handleChangePassword}
            key={this.state.counter}
          />
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

// Header.propTypes = {
//   login: PropTypes.object.isRequired,
//   logOut: PropTypes.func.isRequired,
// };

const mapStateToProps = (state) => ({
  login: state.login || [],
  showWalletBalanceState: state.showWalletBalance,
  cartList: state.cartListDetail,
  buyProductState: state.buyProduct,
  logout: state.logout,
  walletSetting: state.walletSetting,
  regenerateSecKeyState: state.regenerateSecKey,
  authTkn: state.authToken,
  // regenerateTkn: state.regenerateToken,
});

export default withRouter(
  connect(mapStateToProps, {
    logoutUser,
    resetApp,
    showWalletBalance,
    setSelectedCurrency,
    getCartList,
    resetLogout,
    // getRegenerateToken,
  })(withTranslation()(Header))
);
